// Clip and cart lengths in frames. A length that needs an unknown value (the asset's duration or
// offset) is null and left out of totals, never guessed as 0.
import { parseTc, toFrames, framesToTc } from "./timecode.js";

function markFrames(tc) {
  const secs = parseTc(tc);
  return secs == null ? null : toFrames(secs);
}

/** A clip's length in frames, or null while unknown; the lookups (by asset id) return null while unknown. */
export function clipFrames(subclip, { durationFrames, offsetFrames }) {
  const tcIn = markFrames(subclip.tcIn);
  const tcOut = markFrames(subclip.tcOut);
  if (tcIn != null && tcOut != null) return Math.max(0, tcOut - tcIn);
  const duration = durationFrames(subclip.assetID);
  if (tcIn == null && tcOut == null) return duration;
  // marks are source timecode; the asset starts at its offset
  const offset = offsetFrames(subclip.assetID);
  if (offset == null) return null;
  if (tcIn != null) return duration == null ? null : Math.max(0, offset + duration - tcIn);
  return Math.max(0, tcOut - offset);
}

/** { frames, unknown }: the sum of the known lengths and how many were unknown. */
export function cartTotals(subclips, lookups) {
  let frames = 0;
  let unknown = 0;
  for (const subclip of subclips || []) {
    const length = clipFrames(subclip, lookups);
    if (length == null) unknown++;
    else frames += length;
  }
  return { frames, unknown };
}

/** "" while no length is known; else the total, with " +N" for the clips it leaves out. */
export function totalLabel({ frames, unknown }, count) {
  if (unknown === count) return "";
  return framesToTc(frames) + (unknown > 0 ? " +" + unknown : "");
}
